import { getRentPriceInfo } from './price/rent/getRentPriceInfo';
import { getSalePriceInfo } from './price/sale/getSalePriceInfo';
import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isAgent } from './isAgent';
import { isDealRentCianAgency } from './isDealRentCianAgency';

export const priceInfo: TComputedPropMapper<string | undefined> = (props, ctx) => {
  const isUserAgent = isAgent(props, ctx);
  const dealRentExperiment = isDealRentCianAgency(props, ctx);

  return props.offer.dealType === 'rent'
    ? getRentPriceInfo(props.offer, isUserAgent, dealRentExperiment)
    : getSalePriceInfo(props.offer, isUserAgent);
};
